import { call } from '../@';

const verificationUpdateNotification = async (userId: string, notification: string) =>
	await call('user-verificationUpdateNotification', { userId, notification });

export default verificationUpdateNotification;
